import Vue from 'vue';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import index from './store';
import axios from './utils/request';
import checking from './utils/checking';
import momentData from './utils/momentPublic';
import VueCookie from 'vue-cookie';
import 'swiper/dist/css/swiper.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueI18n from 'vue-i18n';
import ni18n from './locales';

import jQuery from 'jquery';
import moment from 'moment';
window.jQuery = window.$ = jQuery;

import {
  Avatar,
  Badge,
  Breadcrumb,
  Dropdown,
  Icon,
  Input,
  Cascader,
  Layout,
  LocaleProvider,
  Menu,
  Tabs,
  Table,
  Form,
  Card,
  Button,
  InputNumber,
  Upload,
  DatePicker,
  Select,
  message,
  Progress,
  Modal,
  Radio,
  Checkbox,
  Popconfirm,
  Notification,
  Carousel,
  Rate,
  collapse,
  spin,
  Tag,
} from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css';

import AOS from 'aos';
import 'aos/dist/aos.css';
// import VueParticles from 'vue-particles';
// Vue.use(VueParticles);

Vue.config.productionTip = false;
Vue.prototype.$checking = checking;
Vue.prototype.$momentData = momentData;
Vue.prototype.$moment = moment;
Vue.prototype.$message = message;
Vue.prototype.$notification = Notification;
router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题

    document.title = to.meta.title;
  } else {
    document.title = '曼德品控';
  }
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;

  next();
});
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/main.less';
Vue.use(VueAxios, axios);
Vue.use(Avatar);
Vue.use(Badge);
Vue.use(Breadcrumb);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Layout);
Vue.use(LocaleProvider);
Vue.use(Menu);
Vue.use(Tabs);
Vue.use(Table);
Vue.use(Card);
Vue.use(Form);
Vue.use(Button);
Vue.use(Cascader);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Upload);
Vue.use(DatePicker);
Vue.use(message);
Vue.use(Progress);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Popconfirm);
Vue.use(VueCookie);
Vue.use(Carousel);
Vue.use(Rate);
Vue.use(VueAwesomeSwiper);
Vue.use(AOS);
Vue.use(VueI18n);
Vue.use(collapse);
Vue.use(spin);
Vue.use(Tag);
Vue.use(ElementUI);

Vue.prototype.config = {
  //图片回显
  /*=======prod========*/
  baseUrlImg: 'https://api.minderworks.com',
  /*======dev=========*/
  // baseUrlImg: 'http://49.4.71.97:8084',
  // baseUrlImg: 'http://49.4.71.97:9688/hzwmj',
  //配置生成二维码后端服务配置
  //prod
  urlImg: 'https://api.minderworks.com',
  //dev
  // urlImg: 'http://192.168.100.85:8080',
  // urlImg: 'http://49.4.71.97:9688/hzwmj',
};
Vue.prototype.$ = jQuery;
const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./components/lang/cn'), // 中文语言包
    'en-US': require('./components/lang/en'), // 英文语言包
  },
});
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0);
//   console.log(to, from, next);
// });
AOS.init({
  duration: 1800,
  easing: 'ease-in-out', //默认动画效果，可以参照animate.css中的各类动画
  once: true,
  mirror: false,
});
new Vue({
  router,
  store: index,
  ni18n,
  i18n,

  render: (h) => h(App),
}).$mount('#app');
